import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinbhandgaonpune() {



const cardData =
  {
    keyword: 'Bus On Rent in Bhandgaon Pune',
    heading: 'Sanavi Travels: Bus On Rent in Bhandgaon Pune',
    headingDescription: 'Sanavi Travels offers reliable and professionally managed Bus On Rent in Bhandgaon Pune, catering to families, villagers, corporate teams, schools, wedding groups, picnic travelers, and outstation passengers. Bhandgaon, located in the Daund region of Pune district, is a developing rural–semi-urban area with strong social, agricultural, and community activity, resulting in frequent demand for organized group transportation. To serve these needs, we provide a versatile fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and large seating-capacity buses suitable for local trips as well as long-distance travel. Every bus is well-maintained with comfortable seating, proper ventilation, smooth suspension, and sufficient luggage space to ensure a relaxed and safe journey for passengers of all ages.',

    top: 'Top Places to Visit Near Bhandgaon Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhandgaon Village",
    "description": "Bhandgaon is a prominent village in Daund taluka known for its close-knit community, agricultural lifestyle, and regular social gatherings. Weddings, religious programs, family events, and community functions frequently take place here, creating strong demand for organized group transportation. Bus rentals help villagers and guests travel together comfortably while avoiding coordination issues and reducing dependence on multiple small vehicles."
  },
  {
    "title": "Daund Connectivity",
    "description": "Bhandgaon enjoys convenient access to Daund town, which acts as a major railway and road junction in the region. Many residents travel to Daund for education, markets, healthcare, and business purposes. Bus hire services provide an efficient solution for group travel between Bhandgaon and Daund, ensuring timely arrivals and comfortable journeys."
  },
  {
    "title": "Pune–Solapur Highway Access",
    "description": "The nearby Pune–Solapur Highway offers excellent connectivity from Bhandgaon to Pune city, Solapur, and other key destinations. This route is commonly used for outstation trips, corporate travel, and pilgrimage tours. Hiring a bus ensures safe highway travel, reduced travel fatigue, and organized movement for large groups."
  },
  {
    "title": "Agricultural Surroundings",
    "description": "The region around Bhandgaon is dominated by fertile agricultural land producing sugarcane, grains, and seasonal crops. Group travel is common for farming activities, cooperative meetings, and market visits. Bus rentals support smooth transportation across rural roads while maintaining passenger comfort and safety."
  },
  {
    "title": "Local Temples and Spiritual Sites",
    "description": "Temples and small spiritual centers around Bhandgaon attract devotees throughout the year, especially during festivals and religious occasions. Bus hire services allow devotees and families to travel together conveniently, making temple visits more organized and economical."
  },
  {
    "title": "Weekly Markets and Rural Bazaars",
    "description": "Nearby weekly markets draw villagers from surrounding areas for trade, shopping, and social interaction. Bus rentals are frequently used for collective travel by farmers, traders, and community members, saving time and travel costs."
  },
  {
    "title": "Wedding Lawns and Event Spaces",
    "description": "Marriage halls and open wedding spaces in and around Bhandgaon depend heavily on bus rentals for guest transportation. Buses help manage large gatherings efficiently, reduce parking congestion, and ensure guests arrive on time."
  },
  {
    "title": "Educational Institutions Nearby",
    "description": "Schools and colleges in the Daund region often organize educational tours, sports events, and cultural programs. Bus hire services ensure safe, supervised, and punctual transportation for students and staff."
  },
  {
    "title": "Picnic and Leisure Areas",
    "description": "Open rural landscapes, small water bodies, and leisure spots near Bhandgaon are popular for school picnics and family outings. Hiring a bus allows groups to enjoy the journey together and return safely."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Bhandgaon offers easy access to Pune, Solapur, Ahmednagar, Shirdi, and other destinations. Bus rentals are ideal for outstation group travel, providing comfort, safety, and affordability for long journeys."
  }
]
,



"services": [
{
"name": "Bus On Rent in Bhandgaon Pune",
"description": "Bus On Rent in Bhandgaon Pune offers spacious, comfortable, and dependable buses for families, schools, corporate groups, and social events. This service is ideal for weddings, religious programs, picnics, school trips, and outstation travel. Our buses are well-maintained with comfortable seating, proper ventilation, smooth suspension, and ample luggage space, ensuring a relaxed journey for all passengers. Experienced drivers ensure punctual pickups, disciplined driving, and complete safety, making group travel organized and stress-free."
},
{
"name": "Bus Hire Bhandgaon",
"description": "Bus Hire Bhandgaon provides flexible and convenient bus rental options for local and long-distance travel. Suitable for village events, family gatherings, and community programs, this service ensures reliable transportation with well-maintained buses and professional drivers."
},
{
"name": "AC Bus Rental Bhandgaon",
"description": "AC Bus Rental Bhandgaon is ideal for summer travel and long journeys, offering air-conditioned interiors, cushioned seating, and enhanced passenger comfort. Perfect for weddings, corporate trips, and outstation tours."
},
{
"name": "Non AC Bus on Rent Bhandgaon",
"description": "Non AC Bus on Rent Bhandgaon offers budget-friendly transportation for short routes, rural travel, school trips, and local group journeys without compromising on safety."
},
{
"name": "Luxury Bus on Rent Bhandgaon Pune",
"description": "Luxury Bus on Rent Bhandgaon Pune delivers a premium travel experience with modern interiors, stylish seating, and superior comfort, ideal for weddings, VIP guests, and special occasions."
},
{
"name": "Mini Bus Hire Bhandgaon",
"description": "Mini Bus Hire Bhandgaon is suitable for small to medium-sized groups such as family outings, office teams, and local events, offering flexibility and economical pricing."
},
{
"name": "32 Seater Bus on Rent Bhandgaon",
"description": "32 Seater Bus on Rent Bhandgaon is perfect for school trips, corporate outings, and medium-sized group travel, balancing capacity and comfort."
},
{
"name": "35 Seater Bus Hire Bhandgaon",
"description": "35 Seater Bus Hire Bhandgaon supports large group travel needs such as weddings, religious tours, and long-distance journeys with organized seating and professional drivers."
},
{
"name": "Bus on Rent Bhandgaon for Wedding",
"description": "Bus on Rent Bhandgaon for Wedding ensures coordinated and timely transportation for wedding guests, reducing travel stress and simplifying event logistics."
},
{
"name": "Bus on Rent Bhandgaon for Corporate",
"description": "Bus on Rent Bhandgaon for Corporate provides professional transportation for employee movement, meetings, conferences, and team outings with punctual service."
},
{
"name": "Bus on Rent Bhandgaon for Picnic",
"description": "Bus on Rent Bhandgaon for Picnic offers safe and enjoyable travel for school picnics, family outings, and group leisure trips."
},
{
"name": "Bus Rental Bhandgaon Outstation",
"description": "Bus Rental Bhandgaon Outstation provides dependable long-distance transportation to nearby cities and pilgrimage destinations with passenger comfort as a priority."
},
{
"name": "Bus Hire Bhandgaon with Driver",
"description": "Bus Hire Bhandgaon with Driver offers chauffeur-driven buses where experienced drivers manage routes, traffic, and safety, allowing passengers to relax."
},
{
"name": "Affordable Bus Rental Bhandgaon Pune",
"description": "Affordable Bus Rental Bhandgaon Pune delivers cost-effective bus hire solutions without compromising cleanliness, safety, or reliability."
},
{
"name": "Best Bus Service Bhandgaon",
"description": "Best Bus Service Bhandgaon is known for clean buses, disciplined drivers, transparent pricing, and customer-focused service, making Sanavi Travels a trusted choice."
}
],
"tableData": [
["Bus On Rent in Bhandgaon Pune", "Bus Hire Bhandgaon"],
["AC Bus Rental Bhandgaon", "Non AC Bus Hire Bhandgaon"],
["Luxury Bus Bhandgaon", "Mini Bus Hire Bhandgaon"],
["32 Seater Bus Bhandgaon", "35 Seater Bus Bhandgaon"],
["Wedding Bus Bhandgaon", "Corporate Bus Bhandgaon"],
["Picnic Bus Bhandgaon", "Outstation Bus Bhandgaon"],
["Bus Hire Bhandgaon with Driver", "Affordable Bus Rental Bhandgaon"],
["Best Bus Service Bhandgaon", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Bhandgaon Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides dependable bus rental services in Bhandgaon Pune for families, schools, and corporate groups."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Buses",
    "WhyChoosedescription": "All buses are regularly serviced and cleaned to ensure a comfortable travel experience."
  },
  {
    "WhyChooseheading": "Experienced Local Drivers",
    "WhyChoosedescription": "Drivers are familiar with Bhandgaon, Daund, Pune, and nearby routes for safe and punctual travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "We follow honest pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock for assistance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Hourly, full-day, multi-day, and outstation rental options are available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Buses are sanitized before every trip to ensure passenger safety."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth operations."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Bhandgaon Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Bhandgaon Pune.'
  },
  {
    question: 'What types of buses are available in Bhandgaon?',
    answer: 'AC buses, Non AC buses, mini buses, luxury buses, and 32-seater and 35-seater buses are available.'
  },
  {
    question: 'Is bus rental available for weddings and picnics?',
    answer: 'Yes, we provide dedicated buses for weddings, picnics, and social events.'
  },
  {
    question: 'Can I book a bus for outstation travel from Bhandgaon?',
    answer: 'Yes, outstation bus rentals are available from Bhandgaon.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are sanitized before each journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Kale',
    feedback: 'We booked a bus from Bhandgaon for a wedding. Very punctual and comfortable service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya More',
    feedback: 'Sanavi Travels arranged a bus for our picnic from Bhandgaon. Clean bus and polite driver.',
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Bhandgaon Pune - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Bhandgaon Pune for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Bhandgaon Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Bhandgaon Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/225.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinbhandgaonpune;